import { SvgIconProps } from '@material-ui/core';
import React from 'react';

const VoidIcon = (props: SvgIconProps): JSX.Element => (
  <svg
    fill="none"
    height="29"
    viewBox="0 0 26 29"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25 28V4C25 3.20435 24.6839 2.44129 24.1213 1.87868C23.5587 1.31607 22.7956 1 22 1H4C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V28L7 25L13 28L19 25L25 28Z"
      stroke="#D82662"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66567"
    />
    <path
      d="M12.6886 19.7825C12.6886 20.2424 13.0615 20.6153 13.5215 20.6153C13.9814 20.6153 14.3543 20.2424 14.3543 19.7825L12.6886 19.7825ZM14.1104 6.67184C13.7851 6.3466 13.2578 6.3466 12.9326 6.67184L7.63245 11.972C7.3072 12.2972 7.3072 12.8245 7.63245 13.1498C7.95769 13.475 8.48501 13.475 8.81025 13.1498L13.5215 8.43855L18.2327 13.1498C18.558 13.475 19.0853 13.475 19.4105 13.1498C19.7358 12.8245 19.7358 12.2972 19.4105 11.972L14.1104 6.67184ZM14.3543 19.7825L14.3543 7.26074L12.6886 7.26074L12.6886 19.7825L14.3543 19.7825Z"
      fill="#D82662"
    />
  </svg>
);

export default VoidIcon;
